import React, { useEffect, useState } from "react";
import DeductionModal from "./deduction-modal";
import { Dropdown } from "antd";
import { BiChevronDown } from "react-icons/bi";
import RestrictionModal from "./restriction-modal";
import useRequest from "../../../components/hooks/use-request";
import RemoveRestriction from "./remove-restriction";
const WalletBalance = ({ account, refetchAccount }: any) => {
  const [open, setOpen] = useState(false);
  const [restrictionModalOpen, setRestrictionModalOpen] = useState(false);
  const [restrictionType, setRestrictionType] = useState("");
  const [restriction, setRestriction] = useState<any>(null);
  const [removeRestrictionModalOpen, setRemoveRestrictionModalOpen] =
    useState(false);

  const { makeRequest, loading } = useRequest(
    "/users/restriction/history",
    "GET"
  );

  const fetchRestrictionHistory = async () => {
    const params: {
      limit: number;
      page: number;
      user_id: string;
      status: string;
    } = {
      limit: 10,
      page: 1,
      user_id: account?.id,
      status: "active",
    };
    const [response] = await makeRequest(undefined, params);
    setRestriction(response?.data[0] || {});
  };

  useEffect(() => {
    fetchRestrictionHistory();
  }, [account]);

  const items = [
    {
      label: "Partial restriction",
      key: "1",
      onClick: () => {
        setRestrictionType("partial");
        setRestrictionModalOpen(true);
      },
    },
    {
      label: "Full restriction",
      key: "2",
      onClick: () => {
        setRestrictionType("full");
        setRestrictionModalOpen(true);
      },
    },
  ];

  const modifyItems = [
    {
      label: "Edit restricted amount",
      key: "1",
      onClick: () => {
        setRestrictionModalOpen(true);
        setRestrictionType(restriction?.type);
      },
    },
    {
      label: "Remove restriction",
      key: "2",
      onClick: () => {
        setRemoveRestrictionModalOpen(true);
        setRestrictionType(restriction?.type);
      },
    },
  ];

  return (
    <div className="bg-white border border-[#fff] p-4 rounded-lg w-full">
      <p className="font-medium text-[#475467]">Vendstash wallet balance</p>
      <p className="text-2xl font-bold">₦ {account?.balance}</p>
      <div className="flex gap-2 mt-4">
        <button
          className="bg-[#0979A1] text-[#fff] px-4 py-2 rounded-lg text-sm font-medium"
          onClick={() => setOpen(true)}
        >
          Deduct wallet balance
        </button>
        {restriction?.id ? (
          <Dropdown menu={{ items: modifyItems }} trigger={["click"]}>
            <button className="bg-[#0979A1] text-[#fff] px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2">
              Modify restriction{" "}
              <BiChevronDown className="shrink-0" size={16} />
            </button>
          </Dropdown>
        ) : (
          <Dropdown menu={{ items }} trigger={["click"]}>
            <button className="bg-[#0979A1] text-[#fff] px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2">
              Restrict withdrawal{" "}
              <BiChevronDown className="shrink-0" size={16} />
            </button>
          </Dropdown>
        )}

        {/* <button className="bg-red-500 text-[#fff] px-4 py-2 rounded-lg text-sm font-medium">
          Restrict withdrawal
        </button> */}
      </div>
      {restriction?.id && (
        <p className="text-sm text-[#8B8B8C] font-medium mt-2">
          {restriction?.type === "partial"
            ? `₦${restriction?.amount} restricted from this wallet`
            : "You have fully restricted this wallet"}
        </p>
      )}
      <DeductionModal
        open={open}
        onCancel={() => setOpen(false)}
        account={account}
        refetchAccount={refetchAccount}
      />
      <RestrictionModal
        open={restrictionModalOpen}
        onCancel={() => setRestrictionModalOpen(false)}
        account={account}
        refetchAccount={refetchAccount}
        refetchRestriction={fetchRestrictionHistory}
        restriction={restriction}
        restrictionType={restrictionType}
      />
      <RemoveRestriction
        open={removeRestrictionModalOpen}
        onCancel={() => setRemoveRestrictionModalOpen(false)}
        account={account}
        refetchAccount={refetchAccount}
        restriction={restriction}
        refetchRestriction={fetchRestrictionHistory}
      />
    </div>
  );
};

export default WalletBalance;
